const TOKEN_MODEL_CLASS_NAME = 'Token'

const TOKEN_MODEL_KEY = {
  TYPE: 'type',
  VALUE: 'value',
  EXPIRE_AT: 'expireAt',
  USED_AT: 'usedAt'
  // Foreign keys
}

const TOKEN_MODEL_KEY_POINTER = TOKEN_MODEL_KEY.VALUE

export {
  TOKEN_MODEL_CLASS_NAME,
  TOKEN_MODEL_KEY,
  TOKEN_MODEL_KEY_POINTER
}
